var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('img',{staticClass:"card__img",attrs:{"src":_vm.info.imageUrl,"alt":""}}),_c('p',{staticClass:"card__text"},[_vm._v(_vm._s(_vm.info.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }